import { render } from "./CourseCardHigh.vue?vue&type=template&id=cd16ed18&scoped=true&ts=true"
import script from "./CourseCardHigh.vue?vue&type=script&lang=ts"
export * from "./CourseCardHigh.vue?vue&type=script&lang=ts"

import "./CourseCardHigh.vue?vue&type=style&index=0&id=cd16ed18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd16ed18"],['__file',"src/components/courses/CourseCardHigh.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd16ed18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd16ed18', __exports__)) {
    api.reload('cd16ed18', __exports__)
  }
  
  module.hot.accept("./CourseCardHigh.vue?vue&type=template&id=cd16ed18&scoped=true&ts=true", () => {
    api.rerender('cd16ed18', render)
  })

}


export default __exports__